import { render, staticRenderFns } from "./CompanyController.vue?vue&type=template&id=3cde096c"
import script from "./CompanyController.vue?vue&type=script&lang=js"
export * from "./CompanyController.vue?vue&type=script&lang=js"
import style0 from "./CompanyController.vue?vue&type=style&index=0&id=3cde096c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports